const FeatureRolloutLogPerformanceConstants = {
  LOAD_START: "featureRolloutLogPerformance/LOAD_START",
  CHECK_OVERVIEW_MAIN_FUNCTIONALITY: "featureRolloutLogPerformance/CHECK_OVERVIEW_MAIN_FUNCTIONALITY",
  SET_OVERVIEW_MAIN_FUNCTIONALITY: "featureRolloutLogPerformance/SET_OVERVIEW_MAIN_FUNCTIONALITY",
  CHECK_OVERVIEW_FULL_LOAD: "featureRolloutLogPerformance/CHECK_OVERVIEW_FULL_LOAD",
  SET_OVERVIEW_FULL_LOAD: "featureRolloutLogPerformance/SET_OVERVIEW_FULL_LOAD",
  CHECK_PROGRESSIONS_MAIN_FUNCTIONALITY: "featureRolloutLogPerformance/CHECK_PROGRESSIONS_MAIN_FUNCTIONALITY",
  SET_PROGRESSIONS_MAIN_FUNCTIONALITY: "featureRolloutLogPerformance/SET_PROGRESSIONS_MAIN_FUNCTIONALITY",
  CHECK_PROGRESSIONS_FULL_LOAD: "featureRolloutLogPerformance/CHECK_PROGRESSIONS_FULL_LOAD",
  SET_PROGRESSIONS_FULL_LOAD: "featureRolloutLogPerformance/SET_PROGRESSIONS_FULL_LOAD",
  CHECK_PROGRESSIONS_SCORECARDS_FULL_LOAD: "featureRolloutLogPerformance/CHECK_PROGRESSIONS_SCORECARDS_FULL_LOAD",
  SET_PROGRESSIONS_SCORECARDS_FULL_LOAD: "featureRolloutLogPerformance/SET_PROGRESSIONS_SCORECARDS_FULL_LOAD",
  CHECK_ALERTS_FULL_LOAD: "featureRolloutLogPerformance/CHECK_ALERTS_FULL_LOAD",
  SET_ALERTS_FULL_LOAD: "featureRolloutLogPerformance/SET_ALERTS_FULL_LOAD",
  MAIN_FUNCTIONALITY: "featureRolloutLogPerformance/MAIN_FUNCTIONALITY",
  FULL_LOAD: "featureRolloutLogPerformance/FULL_LOAD"
};
export {
  FeatureRolloutLogPerformanceConstants as default
};
//# sourceMappingURL=FeatureRolloutLogPerformanceConstants.js.map
